import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import AccountAPI from '@/modules/account/constants/account.api.uri.const.ts'
import {markRaw} from 'vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum VersionActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface VersionListStore {
  action_type: VersionActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Object,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useVersionListStore = defineStore('system.version', {
  state: (): VersionListStore => ({
    action_type: VersionActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'keywords',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Tình trạng',
        placeholder: 'Chọn tình trạng',
        value: '',
        options: [
          { label: 'Tất cả', value: '' },
          { label: 'Đang hoạt động', value: 'live' },
          { label: 'Ngưng hoạt động', value: 'deprecated' },
        ],
      },
      {
        key: 'request-date',
        type: 'date-range',
        label: 'Thời gian hoạt động',
        placeholder: 'Chọn thời gian',
        value: '',
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách phiên bản',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        status: { label: 'Trạng thái', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        version_name: { label: 'version', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        api_version: { label: 'API version', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        api_url: { label: 'API BaseURL', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        android_version: { label: 'Phiên bản Android', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        android_market_url: { label: 'Link tải Android', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        ios_version: { label: 'Phiên bản iOS', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        ios_market_url: { label: 'Link tải iOS', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        webview_version: { label: 'Phiên bản webview', component: markRaw(TextCell), visible: true, sort: false, config: {} },
        period_start_at: { label: 'Thời gian open', component: markRaw(DateTimeCell), visible: true, sort: false, config: {} },
        period_end_at: { label: 'Thời gian end', component: markRaw(DateTimeCell), visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày tạo', component: markRaw(DateTimeCell), visible: true, sort: '', config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách phiên bản',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = VersionActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = VersionActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = VersionActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise((resolve, reject) => {
        try{
          this.action_type = VersionActionTypes.FETCHING
          const sort = this.sortFilter
          const filter = {
            page: this.page,
            pageSize: this.pageSize,
            sort
          }

          // const res = APIClient.get(AccountAPI.list, {
          //   params: filter
          // })
          const res = {}
          setTimeout(()=>{
            this.data = {
              list: [
                {id: 1, status: 'Đang hoạt động', version_name: '1.0.1', api_version: '1.0.1', api_url: 'https://api.onenetwork.vn', android_version: '1.0.1', android_market_url: '', ios_version: '1.0.1', ios_market_url: '', webview_version: '1.0.1', period_start_at: '2025-05-01 00:00:01', period_end_at: '', created_at: '2025-05-01'},
                {id: 1, status: 'Ngưng hoạt động', version_name: '1.0.0', api_version: '1.0.0', api_url: 'https://api.onenetwork.vn', android_version: '1.0.0', android_market_url: '', ios_version: '1.0.0', ios_market_url: '', webview_version: '1.0.0', period_start_at: '2025-04-01 00:00:00', period_end_at: '2025-05-01 00:00:00', created_at: '2025-05-01'},
              ],
              totalRecords: 100,
              totalPage: 10
            }
            this.action_type = VersionActionTypes.FETCH_SUCCESS
            resolve(res)
          }, 300)
        } catch (e) {
          this.action_type = VersionActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
